import { style } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { PartConfigModelType, PartConfigSuspension } from 'app/core/model/entity-model';
import { PartConfigModelSize } from 'app/core/model/part-config-model-size';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import validationEngine from 'devextreme/ui/validation_engine';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-suspension-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Suspension</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="suspension" [formData]="suspension" validationGroup="validationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="value" [label]="{ text: 'Part# Value' }">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                    <div class="d-flex">
                        <div class="d-flex flex-column ms-3 me-3">
                            <table class="mt-3 table table-hover table-min-width">
                                <thead>
                                    Tires
                                    <i class="ms-2 fa fa-plus" (click)="add('Tire')"></i>
                                </thead>
                                <tbody *ngIf="suspension && suspension._tireSizes?.length > 0">
                                    <tr *ngFor="let tire of suspension._tireSizes">
                                        <td>{{ tire.name }}</td>
                                        <td></td>
                                        <td class="icon-collapse-horizontal"><i class="fa fa-times" (click)="deleteLink(tire.id, 'Tire')"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    styles: `
        .table-min-width {
            min-width: 150px;
        }
    `,
    standalone: false,
})
export class SuspensionDialogComponent {
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    uow = inject(GenesisUnitOfWork);
    modalService = inject(BsModalService);
    
    result = new Subject<{ success: boolean }>();
    suspension: PartConfigSuspension;

    modelTypes: PartConfigModelType[];
    modelType: PartConfigModelType;
    displayOrder: number;
    validationGroup: 'validationGroup';
    canChangeModelType = false;

    async ngOnInit() {
        await this.getData();
        console.log('suspension', this.suspension);
    }


    async getData() {
        if (!this.suspension) {
            this.suspension = this.uow.partConfigSuspensions.createEntity({
                displayOrder: this.displayOrder,
                created: new Date(),
                createdBy: this.auth.currentUser?.userName,
            }) as PartConfigSuspension;
        } 
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }
    async add(mode?: string) {
        let array = [];
        if (mode === 'Tire') array = await this.uow.partConfigTires.whereActive();

        array = array.filter((x) => {
            if (mode === 'Tire') return !this.suspension._tireSizes?.map((y) => y.tireId).includes(x.id);
        });
        if (array.length === 0) {
            this.appInfo.notifyToast(`No more ${mode}s to add`, 'info');
            return;
        }

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: `Add ${mode}`,
                dialogPrompt: `Add`,
                dialogValueArray: array,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                const newLink = this.uow.partConfigSuspensionTireLinks.createEntity({
                    partConfigSuspensionId: this.suspension.id,
                    partConfigTireId: result.value,
                });
                await this.uow.commit();
                // console.log(this.modelSize);
                if (mode === 'Tire') this.suspension._tireSizes.push({ tireId: result.value, name: array.find((x) => x.id === result.value).name, id: newLink.id });
                await this.getData();
            } else {
                // this.uow.rollback();
            }
            modalRef.hide();
        });
    }
    async deleteLink(id: number, mode?: string) {
        console.log('deleteLink', id, mode);
        const result = await confirm(`Are you sure you want to delete this ${mode} from this Model Size?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        const link = await this.uow.partConfigSuspensionTireLinks.byId(id);
        if (link) {
            link.deleted = new Date();
            await this.uow.commit();
        }
        if (mode === 'Tire') this.suspension._tireSizes = this.suspension._tireSizes.filter((x) => x.id !== id);
        await this.getData();
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.suspension } as any);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
